module.exports = __webpack_public_path__ + "img/wardrobe.0fc4f1bf.png";